// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"45faee66","455":"dc213100"}[chunkId] + ".chunk.js";
};